import { Box } from "@mui/material";
import EntertainementEntityList from "./EntertainementEntityList";

const EntityGridList = ({ scrollRef, entertainment_entity_data, setEntertainmentEntity, handleCreateUpdateClick }) => {
  return (
    <Box
      ref={scrollRef}
      sx={{
        height: '100%',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexGrow: 1,
        flexDirection: "row",
        gap: 0,
        overflowY: 'auto',
      }}>

      {<EntertainementEntityList entertainment_entity_data={entertainment_entity_data} setEntertainmentEntity={setEntertainmentEntity} handleCreateUpdateClick={handleCreateUpdateClick} />}

    </Box>
  );
}


export default EntityGridList;